var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"parametre main-section"},[_c('ParamBanque')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }